import React, { useState } from 'react';
import userAPI from '../../../api/userAPI';
import { User } from '../../../types/User';
import DebounceSelect from './DebounceSelect';

export interface UserValue {
  key: string;
  label: string;
  value: string;
  name: string;
  phoneNum: string;
}

interface UserSearchSelectProps {
  selectedUser: UserValue;
  onChange: (value: UserValue) => void;
  searchMethod?: 'name' | 'phoneNum';
  placeholder?: string;
}

const UserSearchSelect: React.FC<UserSearchSelectProps> = ({ selectedUser, onChange, placeholder, searchMethod = 'name'}) => {

  let fetchOption = fetchUserList;
  if (searchMethod === 'phoneNum') {
    fetchOption = fetchUserListByPhoneNum;
  }

  const value = selectedUser.key ? selectedUser: undefined;
  return (
    <DebounceSelect
      value={value}
      placeholder={placeholder}
      fetchOptions={fetchOption}
      onChange={(newValue) => {
        console.log('onChange newValue', newValue);
        onChange(newValue as UserValue);
      }}
      style={{ width: '100%' }}
      optionRender={(option) => {
        return (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
          }}>
            <span>{option.data.name}</span>
            <span>{option.data.phoneNum}</span>
          </div>
        )
      }}
    />
  );
};

async function fetchUserList(username: string): Promise<UserValue[]> {

  return userAPI.searchUserAPI(username)
    .then((users) => {
      if (users.length > 0 )  {
        return users.map(
          (user: User) => ({
            key: user.id,
            label: `${user.name}`,
            value: user.id,
            name: user.name,
            phoneNum: user.phoneNum,
          }),
        );
      } else {
        return [];
      }
    });
}

async function fetchUserListByPhoneNum(phoneNum: string): Promise<UserValue[]> {

  return userAPI.searchUserByPhoneNumAPI(phoneNum)
    .then((users) => {
      if (users.length > 0 )  {
        return users.map(
          (user: User) => ({
            key: user.id,
            label: `${user.phoneNum}`,
            value: user.id,
            name: user.name,
            phoneNum: user.phoneNum,
          }),
        );
      } else {
        return [];
      }
    });
}

export default UserSearchSelect;
